export default class ContentListFilter {
  constructor() {
    this.mapManager = null; // Inizialmente la mappa non è collegata
    this.currentFilter = null;
    this.init();
  }

  init() {
    this.contentListFilter();
  }

  setMapManager(mapManager) {
    this.mapManager = mapManager;
    // Il filtro iniziale può girare prima che la mappa sia pronta:
    // riapplica lo stesso tag anche ai marker.
    if (this.currentFilter !== null) {
      this.mapManager.filterMarkers(this.currentFilter);
    }
  }

  contentListFilter() {
    const getURLParameter = (param) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    };

    const contentLists = document.querySelectorAll(".component.contentlist");

    contentLists.forEach((contentList) => {
      const filterComponent = contentList.querySelector(".component.filter");
      const genericButton = filterComponent?.querySelector(".generic-btn"); // Bottone generico invisibile
      console.log(genericButton);

      if (filterComponent) {
        console.log("Content list con filtro trovata.");

        const filterButtons = filterComponent.querySelectorAll("button");
        filterButtons.forEach((button) => button.classList.remove("active"));

        this.setupFilterListeners(contentList);

        const filterParam =
          getURLParameter("filter") || sessionStorage.getItem("selectedTag");
        let defaultButton = filterParam
          ? filterComponent.querySelector(
              `button[data-filter="${filterParam}"]`
            )
          : genericButton; // Se nessun filtro, usa il generico

        if (defaultButton) {
          const selectedTag = defaultButton.getAttribute("data-filter");
          const title = defaultButton.getAttribute("data-title");
          const description = defaultButton.getAttribute("data-description");

          defaultButton.classList.add("active");
          this.updateContentList(contentList, title, description);

          if (filterParam) {
            sessionStorage.setItem("selectedTag", selectedTag);
          }

          console.log(
            `Filtro iniziale: ${selectedTag}. Mostro le tile con titolo ${title} e descrizione ${description}`
          );
          if (selectedTag != "generic") {
            this.filterTiles(contentList, selectedTag, true);
          } else {
            this.currentFilter = "";
          }
        } else {
          console.log(
            "Nessun filtro attivo. Mostro tutte le tile con titolo generico."
          );
          this.updateContentList(
            contentList,
            genericButton?.getAttribute("data-title"),
            genericButton?.getAttribute("data-description")
          );
          this.filterTiles(contentList, "", false);
        }
      } else {
        console.log("Questa content list non ha un filtro.");
      }
    });
  }

  setupFilterListeners(contentList) {
    const filterButtons = contentList.querySelectorAll(
      ".component.filter button"
    );
    const genericButton = contentList.querySelector(
      ".component.filter .generic-btn"
    ); // Bottone invisibile

    if (filterButtons.length === 0) {
      console.log("Nessun pulsante trovato nel filtro.");
      return;
    }

    filterButtons.forEach((button) => {
      button.addEventListener(
        "click",
        function () {
          const selectedTag = button.getAttribute("data-filter");
          const title = button.getAttribute("data-title");
          const description = button.getAttribute("data-description");

          sessionStorage.setItem("selectedTag", selectedTag);

          this.updateContentList(contentList, title, description);

          filterButtons.forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");

          this.filterTiles(
            contentList,
            selectedTag === "generic" ? "" : selectedTag,
            false
          );

          // SCROLL A INIZIO DELLA CONTENTLIST
          // SCROLL ALLA CONTENTLIST con offset per sticky filter
          const stickyOffset =
            contentList.querySelector(".component.filter")?.offsetHeight || 80;
          const contentListTop =
            contentList.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: contentListTop - stickyOffset - 16, // 16px di margine opzionale
            behavior: "smooth",
          });
        }.bind(this)
      );
    });

    // Se nessun filtro è attivo, usa il titolo e la descrizione generici
    console.log(!sessionStorage.getItem("selectedTag"));
    if (!sessionStorage.getItem("selectedTag")) {
      this.updateContentList(
        contentList,
        genericButton.getAttribute("data-title"),
        genericButton.getAttribute("data-description")
      );
    }
  }

  updateContentList(contentList, title, description) {
    const contentListTitle = contentList.querySelector(".contentlist_title");
    if (!contentListTitle) {
      return;
    }

    const normalizedTitle = (title || "").trim();
    const normalizedDescription = (description || "").trim();

    const syncTextElement = (selector, tagName, className, text) => {
      let element = contentListTitle.querySelector(selector);

      if (text === "") {
        if (element) {
          element.remove();
        }
        return;
      }

      if (!element) {
        element = document.createElement(tagName);
        element.className = className;
        contentListTitle.appendChild(element);
      }

      element.textContent = text;
    };

    syncTextElement(".title", "h2", "title", normalizedTitle);
    syncTextElement(".subtitle", "p", "subtitle", normalizedDescription);
  }

  filterTiles(contentList, selectedTag, isInitialFilter = false) {
    const tiles = Array.from(contentList.querySelectorAll(".tile"));
    this.currentFilter = selectedTag;

    if (tiles.length === 0) {
      console.log("Nessuna tile trovata nella contentlist.");
      if (this.mapManager) {
        this.mapManager.filterMarkers(selectedTag);
      }
      return;
    }

    let matchingTiles = [];
    let nonMatchingTiles = [];

    tiles.forEach((tile) => {
      const tileTags = tile.getAttribute("data-tags") || "";

      if (selectedTag === "sedi" && tileTags.includes("rifornimenti-gpl")) {
        matchingTiles.push(tile);
      } else if (!selectedTag || tileTags.includes(selectedTag)) {
        matchingTiles.push(tile);
      } else {
        nonMatchingTiles.push(tile);
      }
    });

    // Ordina le tile mettendo prima quelle attive
    const sortedTiles = [...matchingTiles, ...nonMatchingTiles];

    sortedTiles.forEach((tile) => {
      contentList.appendChild(tile); // Re-appending le riordina nel DOM

      if (matchingTiles.includes(tile)) {
        tile.classList.remove("inactive");
      } else {
        tile.classList.add("inactive");
      }
    });

    if (this.mapManager) {
      console.log("Aggiorno i marker sulla mappa.");
      this.mapManager.filterMarkers(selectedTag);
    }
  }
}
